<!-- Modal Header -->
<div class="modal-header modal-head">
    <div class="modal-titles">MODIFICA ACCESSORI</div>
</div>

<!-- Modal body -->
<div class="modal-body">
    <form [formGroup]="formBuilder">
        <div class="row">
            <div class="col">
                <div class="m-3">
                    <label for="objModelCreate_index" class="form-label label-fw">Posizione</label>
                    <input type="number" class="modal-input" id="objModelCreate_index" placeholder="Posizione"
                        formControlName="index">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="m-3">
                    <label for="objModelCreate_name" class="form-label label-fw">Nome *</label>
                    <input type="text" class="modal-input" id="objModelCreate_name"
                        [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true}"
                        placeholder="Name" formControlName="name">
                    <div class="invalid-feedback" *ngIf="formControls.name.touched">
                        <span *ngIf="formControls.name.errors && formControls.name.errors?.required">
                            Nome è richiesto
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <div class="row">
        <div class="col">
            <div class="m-3">
                <label for="objGetModel_createdAt" class="form-label label-fw">Creato il</label>
                <input type="text" id="objGetModel_createdAt" class="modal-input form-control"
                    placeholder="Creato il" value="{{objGetModel.createdAt | date: 'dd/MM/yyyy'}}" disabled>
            </div>
        </div>
        <div class="col">
            <div class="m-3">
                <label for="objGetModel_createdBy" class="form-label label-fw">Creato Da</label>
                <input type="text" id="objGetModel_createdBy" class="modal-input form-control"
                    placeholder="Creato Da" value="{{objGetModel.createdBy}}" disabled>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="m-3">
                <label for="objGetModel_modifiedAt" class="form-label label-fw">Modificato il</label>
                <input type="text" id="objGetModel_modifiedAt" class="modal-input form-control"
                    placeholder="Modificato il" value="{{objGetModel.modifiedAt | date: 'dd/MM/yyyy'}}" disabled>
            </div>
        </div>
        <div class="col">
            <div class="m-3">
                <label for="objGetModel_modifiedBy" class="form-label label-fw">Modificato Da</label>
                <input type="text" id="objGetModel_modifiedBy" class="modal-input form-control"
                    placeholder="Modificato Da" value="{{objGetModel.modifiedBy}}" disabled>
            </div>
        </div>
    </div>
    <!-- Modal footer -->
    <div class="modal-foot">
        <div class="row my-3 text-center">

            <button type="button" class="btn btn-fw text me-3" (click)="save()">Salva modifiche</button>
            <button type="button" class="btn btn-outline-fw text"
                (click)="cancel()">Annulla</button>

        </div>
    </div>
</div>